import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetIssuedCardRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetIssuedCardResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getIssuedCard = (request: GetIssuedCardRequest, options?: CashRequestOptions) =>
  post<GetIssuedCardRequest, GetIssuedCardResponse>('/2.0/cash/get-issued-card', request, {
    ...options,
    rejectOnError: true,
  })
